module.exports = __webpack_public_path__ + "static/media/3-_DSC8653.7fb2760b.jpg";